import { useMutation } from "@apollo/client";
import { toast } from "react-toastify";
import { SCAN_STOCK_UNIT } from "../stock-scan.queries";
import {
  ScanStockUnitMutation,
  ScanStockUnitMutationVariables,
} from "../../../__generated__/ScanStockUnitMutation";

export const useScanStockUnit = () => {
  const [mutate, { loading, data }] = useMutation<
    ScanStockUnitMutation,
    ScanStockUnitMutationVariables
  >(SCAN_STOCK_UNIT);

  const scan = async (variables: ScanStockUnitMutationVariables) => {
    try {
      const { data } = await mutate({ variables });
      if (!data?.scanStockUnit?.ok) {
        throw Error(data?.scanStockUnit?.error ?? "Error");
      }
      return data.scanStockUnit.stockUnit;
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
      return null;
    }
  };

  return { scan, loading, data };
};
